import { BookingStateEnum } from '@xeetr/types/enums'
import { BaseBookingModel, ViewEmployeeAbsence, ViewFoodEvent } from '@xeetr/types/models'
import { DATETIME_FORMAT } from '@xeetr/types/utils'
import { format } from 'date-fns'
import { Loader2 } from 'lucide-react'
import { useEffect } from 'react'

interface Props {
  booking: BaseBookingModel
  data: ViewFoodEvent | ViewEmployeeAbsence | undefined
  isLoading: boolean
  getEventDetails: (id: string) => void
  getEmployeeAbsence: (id: string) => void
}

const DeleteDialogContent = ({
  booking,
  data,
  isLoading,
  getEventDetails,
  getEmployeeAbsence,
}: Props) => {
  useEffect(() => {
    switch (booking.state?.status) {
      case BookingStateEnum.ABSENCE:
        getEmployeeAbsence(booking.id)
        break
      case BookingStateEnum.EVENT:
        getEventDetails(booking.id)
        break
      default:
        break
    }
  }, [])

  if (isLoading) {
    return (
      <div className="flex justify-center p-4">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    )
  }

  switch (booking.state?.status) {
    case BookingStateEnum.EVENT:
      const event = data as ViewFoodEvent
      return (
        <span>
          Soll das Event <b>{event?.name}</b> vom <b>{event?.from}</b> bis <b>{event?.until}</b>{' '}
          wirklich gelöscht werden?
        </span>
      )
    case BookingStateEnum.ABSENCE:
      const absence = data as ViewEmployeeAbsence
      return (
        <span>
          Soll die Abwesenheit für <b>{absence?.employee}</b> vom{' '}
          <b>{format(absence?.from, DATETIME_FORMAT)}</b> bis{' '}
          <b>{format(absence?.until, DATETIME_FORMAT)}</b> wirklich gelöscht werden?
        </span>
      )
    default:
      return ''
  }
}

export default DeleteDialogContent
